import { default as http } from "../rest/http";

export const fetchUsersList = async (page: number, per_page: number, orgId: number) => {
  try {
    const url  = `/master-data/users?page=${page}&per_page=${per_page}&organization_id=${orgId}`;
    const response = await http.get(url);
    return response;
  } catch (error) {
    console.error("Error fetching users:", error);
    throw error;
  }
};

export const fetchSearchedUsersList = async (page: number, per_page: number, orgId: number, searchText: string|undefined) => {
  try {
    let url=`/master-data/users?page=${page}&per_page=${per_page}&organization_id=${orgId}`;
    if (searchText)
    {
       url  = `/master-data/users?page=${page}&per_page=${per_page}&organization_id=${orgId}&searchString=${encodeURIComponent(searchText)}`;
    }
   
    const response = await http.get(url);
    return response;
  } catch (error) {
    console.error("Error fetching users:", error);
    throw error;
  }
};

export const fetchUserProfile = async (UserId:string) => {
  try {
    let url=`/master-data/users/${UserId}`;
   
    const response = await http.get(url);
    return response;
  } catch (error) {
    console.error("Error fetching users:", error);
    throw error;
  }
};

export const createUser = async (userData: {
  organization_id: number;
  email: string;
  first: string;
  last: string;
  user_role: string;
  send_invite: boolean;
}) => {
  try {
    const response = await http.post('/master-data/users', userData);
    return response;
  } catch (error) {
    console.error("Error creating user:", error);
    throw error;
  }
};

export const uploadBulkUsers = async (
  file: File,
  orgId: number,
  sendInvite: boolean,
  removeUsers?: boolean
) => {
  try {
    const formData = new FormData();
    formData.append('file', file);

    // Build URL with required params
    let url = `/master-data/bulk/upload-users?orgId=${orgId}&sendInvite=${sendInvite}`;
    if (removeUsers) {
      url += `&removeUsers=${removeUsers}`;
    }

    // File is sent as multipart/form-data
    const response = await http.post(url, formData, 'multipart/form-data');
    return response;
  } catch (error) {
    console.error("Error uploading bulk users:", error);
    throw error;
  }
};

export const checkUploadStatus = async (jobId: string) => {
  try {
    const url = `/master-data/bulk/upload-status/${jobId}`;
    const response = await http.get(url);
    return response;
  } catch (error) {
    console.error("Error checking upload status:", error);
    throw error;
  }
};

// Updated: accept an email address and send it as the payload per API requirement
export const resetPassword = async (email: string) => {
  try {
    const url = `/master-data/account/reset-password`;
    const response = await http.post(url, { email });
    return response;
  } catch (error) {
    console.error("Error resetting password:", error);
    throw error;
  }
};

export const updateUserProfile = async (userId: string, userData: {
  first: string;
  last: string;
  email: string;
  user_role: string;
  mobile_phone: string;
  external_unique_id: string;
  organization_id: number;
}) => {
  try {
    const url = `/master-data/users/${userId}`;
    const response = await http.put(url, userData);
    return response;
  } catch (error) {


    throw error;
  }
};

export const updateUserStatus = async (userId: string, isActive: boolean) => {
  try {
    const url = `/master-data/users/${userId}/status`;
    const response = await http.patch(url, { is_active: isActive });
    return response;
  } catch (error) {
    console.error("Error updating user status:", error);
    throw error;
  }
};

export const sendUserInvite = async (userId: string) => {
  try {
    const url = `/master-data/users/${userId}/send-invite`;
    const response = await http.post(url, {});
    return response;
  } catch (error) {
    console.error("Error sending user invite:", error);
    throw error;
  }
};
